import { getToken as getAppCheckToken } from "firebase/app-check";
import { getIdToken, type User } from "firebase/auth";
import { createControlApiClient } from "../lib/api";
import type { WebEnv } from "../lib/env";
import { getFirebaseClient } from "./firebase";

export async function notifySignupBestEffort(env: WebEnv, user: User): Promise<void> {
  try {
    const client = createControlApiClient(
      env,
      () => getIdToken(user),
      async () => {
        const { appCheck } = getFirebaseClient(env);
        if (!appCheck) return null;
        const { token } = await getAppCheckToken(appCheck);
        return token;
      }
    );
    await client.notifySignup();
  } catch {
    return;
  }
}
